<template>
  <a-modal class="date-modal-css" v-model="modal" title="请输入修改的考核交期" width="90%" :maskClosable="false" :closable="true" :destroyOnClose="true">
    <ls-table-layout>
<!--      <div class="table-page-search-wrapper" style="text-align: right" slot="search">
        是否加载关联工单:
        <a-radio-group v-model="loadAssociateWorkOrderIs" @change="changeRelatedOrder">
          <a-radio :value="1">是</a-radio>
          <a-radio :value="0">否</a-radio>
        </a-radio-group>
      </div>-->
      <div class="table-page-operator-wrapper" slot="btn">
        <a-button type="primary" @click="handleFill">一键填充</a-button>
        <fill-modal ref="fillModalRef" :loopUpData="loopUpData" @fillData="handleToFill" />
      </div>
      <template v-slot:table>
        <div class="page-header-content" v-if="modal">
          <a-form-model ref="baseForm" class="baseForm" :model="formData">
            <ls-api-table
              ref="dataTable"
              :columns="columns"
              :dataSource="formData.infos"
              :tableProps="{}"
              :selectedRows.sync="selectedRows"
              :multi-select="true"
              rowKey="id"
              :pagination="false"
              :scroll="{ y:400, x: 1200 }"
              @selectedRowChange="onSelectChange"
            >
              <template slot="dateFormat" slot-scope="text">
                <span>{{ text.text && $moment(text.text).format('YYYY-MM-DD') }}</span>
              </template>
              <!--原考核交期-->
              <template slot="assessmentDeliveryDate" slot-scope="{text,record}">
                <span v-if="record.wipEntityFlag==='FINISHED_PRODUCT_JOB'">{{ text && $moment(text).format('YYYY-MM-DD') }}</span>
                <span v-else>{{ text && $moment(text).format('YYYY-MM-DD HH:mm:ss') }}</span>
              </template>
              <!--是否主动变更-->
              <span slot="activePassiveTitle">
                <i class="toRequired">*</i>是否主动变更
              </span>
              <template slot="activePassive" slot-scope="{text,record,index}">
                <a-form-model-item
                  :rules="{'required':true,'message':' ','trigger':'blur'}"
                  :prop="`infos.${index}.activePassive`">
                  <a-select v-model="record.activePassive" allowClear @change="onChangeActivePassive(record)">
                    <a-select-option v-for="item in updateMethodList" :key="item.lookupCode">{{ item.lookupValue }}</a-select-option>
                  </a-select>
                </a-form-model-item>
              </template>
              <!--变更类型-->
              <span slot="changeTypeTitle">
                <i class="toRequired">*</i>变更类型
              </span>
              <template slot="changeType" slot-scope="{text,record,index}">
                <a-form-model-item
                  :rules="{'required':true,'message':' ','trigger':'blur'}"
                  :prop="`infos.${index}.changeType`">
                  <a-select v-model="record.changeType" allowClear @change="onChangeChangeType(record)">
                    <a-select-option v-for="item in updateTypeList" :key="item.lookupCode">{{ item.lookupValue }}</a-select-option>
                  </a-select>
                </a-form-model-item>
              </template>
              <!--变更类型-->
              <span slot="assessmentChangeQuantityTitle">
                <i class="toRequired">*</i>交期变更套数
              </span>
              <template slot="assessmentChangeQuantity" slot-scope="{text,record,index}">
                <a-form-model-item
                  :rules="{'required':true,'message':' ','trigger':'blur'}"
                  :prop="`infos.${index}.assessmentChangeQuantity`">
                  <a-input-number
                    style="width: 100%"
                    v-model="record.assessmentChangeQuantity"
                    :min="0"
                    :max="Number(record.planQuantity || 0)"
                    :parser="(value) => `${value}`.replace(/\D/g, '')"
                    :formatter="(value) => `${value}`.replace(/\D/g, '')"
                  />
                </a-form-model-item>
              </template>
              <!--新考核交期-->
              <span slot="newAssessmentDeliveryDateTitle">
                <i class="toRequired">*</i>新考核交期
              </span>
              <template slot="newAssessmentDeliveryDate" slot-scope="{text,record,index}">
                <a-form-model-item
                  :rules="{'required':true,'message':' ','trigger':'change'}"
                  :prop="`infos.${index}.newAssessmentDeliveryDate`">
                  <!--零部件要求展示时分秒，组装成品不用展示时分秒-->
                  <a-date-picker
                    style="min-width: 160px"
                    v-if="record.wipEntityFlag==='COMPONENT_JOB'"
                    v-model="record.newAssessmentDeliveryDate"
                    format="YYYY-MM-DD HH:mm:ss"
                    valueFormat="YYYY-MM-DD HH:mm:ss"
                    :show-time="{ defaultValue: moment('12:00:00', 'HH:mm:ss') }"
                  />
                  <a-date-picker
                    v-else
                    style="min-width: 160px"
                    v-model="record.newAssessmentDeliveryDate" valueFormat="YYYY-MM-DD 23:59:59" />
                </a-form-model-item>
              </template>
              <!--变更责任方-->
              <span slot="responsiblePartyTitle">
                <i class="toRequired">*</i>变更责任方
              </span>
              <template slot="responsibleParty" slot-scope="{text,record,index}">
                <a-form-model-item
                  :rules="{'required':true,'message':' ','trigger':'blur'}"
                  :prop="`infos.${index}.responsibleParty`">
                  <a-select
                    show-search
                    option-filter-prop="children"
                    v-model="record.responsibleParty"
                    allowClear
                    mode="multiple"
                    :maxTagCount="2"
                    @change="onChangeResponsibleParty(record)">
                    <a-select-option v-for="item in changeLiabilityList" :key="item.lookupCode">{{ item.lookupValue }}</a-select-option>
                  </a-select>
                </a-form-model-item>
              </template>
              <!--变更原因-->
              <span slot="changeReasonTitle">
                <i class="toRequired">*</i>变更原因
              </span>
              <template slot="changeReason" slot-scope="{text,record,index}">
                <a-form-model-item
                  :rules="{'required':true,'message':' ','trigger':'blur'}"
                  :prop="`infos.${index}.changeReason`">
                  <a-input type="textarea" :autoSize="{minRows:2}" v-model="record.changeReason" :maxLength="200" />
                </a-form-model-item>
              </template>
              <span slot="operation" slot-scope="{ text, record, index }">
                <a-popconfirm
                  title="确定要删除吗？"
                  ok-text="确定"
                  cancel-text="取消"
                  @confirm="handleDel(index, record)"
                >
                  <a>删除</a>
                </a-popconfirm>
              </span>
            </ls-api-table>
          </a-form-model>
        </div>
      </template>
    </ls-table-layout>
    <template #footer>
      <div class="footer-btn-wrapper">
        <a-button @click="onCancel">取消</a-button>
        <a-button type="primary" :loading="tableLoading" @click="onSubmit">提交审批</a-button>
      </div>
    </template>
  </a-modal>
</template>

<script>
import cacheRequest from '@/mixins/cacheRequest'
import {
  apiGetAssessmentDeliveryDateUpdateList,
  apiMesDispatchAssessmentDeliveryDateUpdate,
  apiSubmitAssessmentDeliveryDateUpdate
} from '@/api/mes/workOrderManage/workOrderDesk'
import moment from 'moment';
import { fixedTable } from 'lsmy-libs';
import fillModal from '@/views/mes/workOrderManage/workOrderDesk/components/fill-modal.vue'
import { isNil } from 'lodash'
import cloneDeep from 'lodash.clonedeep'

export default {
  name: 'UpdateAssessmentDeliveryDate',
  components: { fillModal },
  data() {
    return {
      // 表格多选
      selectedRowKeys: [],
      selectedRows: [],
      modal: false,
      loadAssociateWorkOrderIs: 0, // 是否关联工单，默认为否
      typeFlag: '', // 类型标识
      selectRows: [], // 选择的数据
      formData: { infos: [] },
      updateTypeList: [], // 变更类型
      updateMethodList: [], // 是否主动变更
      changeLiabilityList: [], // 变更责任方
      tableLoading: false, // table加载
      // 表格字段
      columns: [
        { title: '计划单号', width: 100, dataIndex: 'orderNo', align: 'center' },
        { title: '加工组织', dataIndex: 'desOrganizationName', width: 140, align: 'center' },
        { title: '工单号', width: 130, dataIndex: 'wipEntityName', align: 'center' },
        { title: '工单状态', width: 85, dataIndex: 'statusName', align: 'center' },
        { title: '数量', width: 65, dataIndex: 'planQuantity', align: 'center' },
        { title: '物料编码', width: 115, dataIndex: 'itemCode', align: 'center' },
        { title: '物料名称', width: 120, dataIndex: 'itemName', align: 'center' },
        {
          title: '原考核交期',
          width: 140,
          dataIndex: 'assessmentDeliveryDate',
          scopedSlots: { customRender: 'assessmentDeliveryDate' },
          align: 'center'
        },
        {
          // title: '是否主动变更',
          width: 90,
          dataIndex: 'activePassive',
          scopedSlots: { customRender: 'activePassive', title: 'activePassiveTitle' },
          align: 'center'
        },
        {
          // title: '变更类型',
          width: 95,
          dataIndex: 'changeType',
          scopedSlots: { customRender: 'changeType', title: 'changeTypeTitle' },
          align: 'center'
        },
        {
          // title: '交期变更套数',
          width: 95,
          dataIndex: 'assessmentChangeQuantity',
          scopedSlots: { customRender: 'assessmentChangeQuantity', title: 'assessmentChangeQuantityTitle' },
          align: 'center'
        },
        {
          // title: '新考核交期',
          width: 165,
          dataIndex: 'newAssessmentDeliveryDate',
          scopedSlots: { customRender: 'newAssessmentDeliveryDate', title: 'newAssessmentDeliveryDateTitle' },
          align: 'center'
        },
        {
          // title: '变更责任方',
          width: 160,
          dataIndex: 'responsibleParty',
          scopedSlots: { customRender: 'responsibleParty', title: 'responsiblePartyTitle' },
          align: 'center'
        },
        {
          // title: '变更原因',
          width: 120,
          dataIndex: 'changeReason',
          scopedSlots: { customRender: 'changeReason', title: 'changeReasonTitle' },
          align: 'center'
        },
        {
          title: '操作',
          width: 65,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          align: 'center',
          stickyFixed: 'right'
        }
      ]
    }
  },
  computed: {
    // 表格数据
    loopUpData() {
      return {
        'updateMethodList': this.updateMethodList,
        'updateTypeList': this.updateTypeList,
        'changeLiabilityList': this.changeLiabilityList
      }
    }
  },
  mixins: [cacheRequest, fixedTable],
  methods: {
    moment,
    // 回填数据
    handleToFill(form) {
      this.formData.infos.forEach((v, index) => {
        if(this.selectedRowKeys.includes(v.id)) {
          Object.keys(form).forEach(key => {
            if(!isNil(form[key]) && form[key] !== '') {
              // 组装成品不用展示时分秒，把时分秒置为23:59:59
              if(key === 'newAssessmentDeliveryDate' && v.wipEntityFlag !== 'COMPONENT_JOB') {
                this.$set(this.formData.infos[index], key, this.moment(form[key]).format('YYYY-MM-DD 23:59:59'))
              } else if(key === 'assessmentChangeQuantity' && Number(form[key]) > Number(v.quantityRemaining)) {
                this.$set(this.formData.infos[index], key, Number(v.quantityRemaining)) // 套数不能大于剩余数量
              } else if(key === 'activePassive') {
                this.$set(this.formData.infos[index], key, form[key])
                const getUpdateMethod = this.updateMethodList?.find(item => item.lookupCode === form[key])
                this.$set(this.formData.infos[index], 'activePassiveName', getUpdateMethod?.lookupValue || '') // 赋值name
              } else if(key === 'changeType') {
                this.$set(this.formData.infos[index], key, form[key])
                const getUpdateType = this.updateTypeList?.find(item => item.lookupCode === form[key])
                this.$set(this.formData.infos[index], 'changeTypeName', getUpdateType?.lookupValue || '') // 赋值name
              } else if(key === 'responsibleParty') {
                this.$set(this.formData.infos[index], key, form[key])
                const getChangeLiability = this.changeLiabilityList?.filter(item => form[key].includes(item.lookupCode))
                if(getChangeLiability?.length > 0) {
                  this.$set(this.formData.infos[index], 'responsiblePartyName', getChangeLiability.map(item => item.lookupValue).join(',')) // 赋值name
                } else {
                  this.$set(this.formData.infos[index], 'responsiblePartyName', '') // 赋值name
                }
                // const getChangeLiability = this.changeLiabilityList?.find(item => item.lookupCode === form[key])
                // this.$set(this.formData.infos[index], 'responsiblePartyName', getChangeLiability?.lookupValue || '') // 赋值name
              } else {
                this.$set(this.formData.infos[index], key, form[key])
              }
            }
          })
        }
      })
    },
    // 一键填充
    handleFill() {
      if (this.selectedRows?.length < 1) {
        this.$message.warning("请选择需修改的工单")
        return
      }
      this.$refs.fillModalRef.show()
    },
    // 行选中
    onSelectChange(selectedRowKeys, selectedRows) {
      // this.selectedRowKeys = selectedRowKeys;
      this.selectedRowKeys = selectedRows.map(v => v.id);
      this.selectedRows = selectedRows
    },
    // 是否关联工单
    changeRelatedOrder() {
      this.selectedRowKeys = []
      this.selectedRows = []
      this.initSearch()
    },
    onCancel() {
      this.modal = false
    },
    // 当【是否主动变更】变化时，赋值name值
    onChangeActivePassive(record) {
      const getUpdateMethod = this.updateMethodList?.find(item => item.lookupCode === record.activePassive)
      record.activePassiveName = getUpdateMethod?.lookupValue ? getUpdateMethod.lookupValue : ''
    },
    // 当【变更类型】变化时，赋值name值
    onChangeChangeType(record) {
      const getUpdateType = this.updateTypeList?.find(item => item.lookupCode === record.changeType)
      record.changeTypeName = getUpdateType?.lookupValue ? getUpdateType.lookupValue : ''
    },
    // 当【变更责任方】变化时，赋值name值
    onChangeResponsibleParty(record) {
      const getChangeLiability = this.changeLiabilityList?.filter(item => record.responsibleParty.includes(item.lookupCode))
      if(getChangeLiability?.length > 0) {
        record.responsiblePartyName = getChangeLiability.map(item => item.lookupValue).join(',')
      } else {
        record.responsiblePartyName = ''
      }
      // record.responsiblePartyName = getChangeLiability?.lookupValue ? getChangeLiability.lookupValue : ''
      // console.log('this.formData.infos', this.formData.infos)
    },
    // 提交
    onSubmit() {
      if(this.formData?.infos?.length === 0) {
        this.$message.warning('提交数据不能为空')
        return
      }
      this.$refs.baseForm.validate(valid => {
          if(valid) {
            this.tableLoading = true
            const apiRequest = this.typeFlag === 'workOrderDesk' ? apiSubmitAssessmentDeliveryDateUpdate : apiMesDispatchAssessmentDeliveryDateUpdate
            const params = cloneDeep(this.formData.infos)
            params.forEach(v => {
              v.responsibleParty = v.responsibleParty.join(',')
            })
            apiRequest(params).then(res => {
              if (res.code === 200) {
                this.$message.success(res?.msg || '操作成功')
                this.modal = false
                this.$emit('reSearch')
              } else {
                this.$message.error(res?.msg || '操作失败')
              }
            }).finally(() => {
              this.tableLoading = false
            })
          } else {
            this.$message.warning('请检查必填项')
          }
      })
    },
    // 初始化搜索
    initSearch() {
      this.tableLoading = true
      const ids = this.selectRows.map(item => item.id)
      apiGetAssessmentDeliveryDateUpdateList(ids, !!this.loadAssociateWorkOrderIs).then(res => {
        if (res.code === 200) {
          if (res?.data?.length > 0) {
            this.$set(this.formData, 'infos', res.data)
          }
        }
        this.$refs.dataTable.myDataSource = res?.data || []
      }).finally(() => {
        this.tableLoading = false
      })
    },
    // 初始化展示
    show(selectedRows, typeFlag) {
      this.selectedRowKeys = []
      this.selectedRows = []
      this.typeFlag = typeFlag; // 区分页面来源的标识
      this.selectRows = selectedRows;
      this.$set(this.formData, 'infos', [])
      this.modal = true
      this.initSearch()
    },
    // 删除
    handleDel(index) {
      this.formData.infos.splice(index, 1);
    }
  },
  created() {
    this.cacheLookupRequest('MES_ASSESSMENT_DELIVERY_DATE_UPDATE_TYPE', { lookupType: 'MES_ASSESSMENT_DELIVERY_DATE_UPDATE_TYPE', current: 1, pageSize: 999 }, 'updateTypeList')
    this.cacheLookupRequest('MES_ASSESSMENT_DELIVERY_DATE_UPDATE_METHOD', { lookupType: 'MES_ASSESSMENT_DELIVERY_DATE_UPDATE_METHOD', current: 1, pageSize: 999 }, 'updateMethodList')
    this.cacheLookupRequest('MES_JOB_CHANGE_LIABILITY', { lookupType: 'MES_JOB_CHANGE_LIABILITY', current: 1, pageSize: 999 }, 'changeLiabilityList')
  },
  mounted() {
    this.stickyFixedColumns(this.columns)
  }
}
</script>

<style lang="less" scoped>
.date-modal-css{
  /deep/.top-content{
    padding: 0 8px;
    margin-bottom: 0;
  }
  /deep/.btnGroup{
    padding: 0 8px;
  }
  /deep/.ant-form-item-control-wrapper{
    width: 100% !important
  }
  .workOrderTable{
    /deep/ .ant-form-item{
      margin-bottom: 0;
    }
    /deep/ .ant-form-explain, .ant-form-extra{
      min-height: 0;
      height: 0;
    }
    /deep/ .ant-table-tbody tr td {
      padding: 8px 8px;
    }
    /deep/ .ant-table-thead > tr > th {
      padding: 12px 8px;
    }
  }
}
</style>
